<template>
  <div v-show="formField">
    <input 
      type="text" 
      v-model="formField.value" 
      class="form-control" 
      :placeholder="'Entre com o(a) ' + formField.name" 
      :id="formField.objectId" 
      v-if="formField.type === 'text'" 
      :disabled="showSummary"/>
    <masked-input 
      :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]" 
      :guide="false" 
      v-model="formField.dateValue" 
      class="form-control" 
      :placeholder="'Entre com o(a) ' + formField.name" 
      v-else-if="formField.type === 'date'" 
      :disabled="showSummary" />
    <div v-else-if="formField.type === 'file'">
      <span class="btn btn-default btn-file" :disabled="showSummary">
        Escolher...
        <input 
          @change="callOnChange(formField, $event);" 
          type="file" 
          accept=".pdf, .doc, .docx, .dwg, .zip, .rar, application/pdf, image/*" 
          class="form-control" 
          :id="formField.objectId" 
          :disabled="showSummary" />
      </span>
      <span class="text-muted">{{formField.filename}}</span>
    </div>
    <div v-else-if="formField.type === 'document'">
      <document-input-preview :formField="formField" :showSummary="showSummary"></document-input-preview>
      <span class="text-muted">{{formField.filename}}</span>
    </div>
    <select 
      class="form-control" 
      v-model="formField.value" 
      v-else-if="formField.type === 'select'" 
      :disabled="showSummary">
      <option v-for="option in formField.options" v-bind:value="option" :key="option.code">{{ option.code }} - {{ option.name }}</option>
    </select>
    <input 
      type="url" 
      v-model="formField.value" 
      class="form-control" 
      placeholder="http:// ou https://" 
      :id="formField.objectId" 
      v-else-if="formField.type === 'link'" 
      :disabled="showSummary" />
    <textarea 
      rows="4" 
      v-model="formField.value" 
      class="form-control" 
      :placeholder="'Entre com o(a) ' + formField.name" 
      :id="formField.objectId" 
      v-else-if="formField.type === 'textarea'" 
      :disabled="showSummary">
    </textarea>
    <masked-input 
      :mask="[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]" 
      :guide="false" 
      v-model="formField.value" 
      class="form-control" 
      :placeholder="'Entre com o(a) ' + formField.name" 
      v-else-if="formField.type === 'cpf'" 
      :disabled="showSummary" />
    <masked-input 
      :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]" 
      :guide="false" 
      v-model="formField.value" 
      class="form-control" 
      :placeholder="'Entre com o(a) ' + formField.name" 
      :disabled="showSummary"
      v-else-if="formField.type === 'cnpj'" />
    <masked-input 
      :mask="['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]" 
      :guide="false" 
      v-model="formField.value" 
      class="form-control" 
      :placeholder="'Entre com o(a) ' + formField.name" 
      v-else-if="formField.type === 'phone'" 
      :disabled="showSummary" />
    <masked-input 
      :mask="[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]" 
      :guide="false" 
      v-model="formField.value" 
      class="form-control" 
      :placeholder="'Entre com o(a) ' + formField.name" 
      :id="formField.objectId" 
      :disabled="showSummary"
      v-else-if="formField.type === 'number'" />
   <masked-input
      :mask="currencyMask"
      :guide="false"
      v-model="formField.value"
      class="form-control"
      :placeholder="'Entre com o(a) ' + formField.name + ' em R$'"
      :id="formField.objectId"
      :disabled="showSummary"
      v-else-if="formField.type === 'money'" />
    <div v-else-if="formField.type === 'checkbox'">
      <label class="checkbox-inline" v-for="option in formField.options" :key="option.code">
        <input type="checkbox" 
          :value="option" 
          :disabled="showSummary"
          v-model="formField.value" /> {{option.name}}
      </label>
    </div>
    <input 
      type="text" 
      v-bind:value="formField.value" 
      class="form-control" 
      :id="formField.objectId" 
      v-else-if="formField.type === 'computed'" 
      disabled="disabled" />
  </div>

</template>

<script>
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import DocumentInputPreview from '../DocumentInputPreview'

export default {
  props: ['formField', 'onChange', 'showSummary'],
  components: {
    MaskedInput,
    DocumentInputPreview
  },
  methods: {
    callOnChange (formField, event) {
      this.onChange(formField, event)
      this.$forceUpdate()
    },
    currencyMask (rawValue) {
      let numberMask = createNumberMask({
        prefix: '',
        suffix: '',
        includeThousandsSeparator: false,
        allowDecimal: true,
        requireDecimal: true,
        allowLeadingZeroes: false
      })
      let mask = numberMask(rawValue)
      let decimalsRegex = /\.([0-9]{1,2})/
      let result = decimalsRegex.exec(rawValue)
      // In case there is only one decimal
      if (result && result[1].length < 2) {
        mask.push('0')
      } else if (!result) {
        mask.push('0')
        mask.push('0')
      }
      return mask
    }
  }
}
</script>

<style>
.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}
.btn-file input[type=file]:disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// DynamicFormField.vue?1aa3dcdb